import { ProjectsApiResponse, Project, projectSchema, LogApiResponse, logApiResponseSchema } from '@repo/shared/domain';
import { guardedClient as clientRequest, constructQuery } from '@repo/shared/helpers';

export const getProjects = async (params?: {
	tab?: string;
	sort?: string;
	page?: number;
	zoneIds?: string;
	groupIds?: string;
	search?: string;
	from?: string;
	until?: string;
}): Promise<ProjectsApiResponse> => {
	const query = constructQuery({
		...params,
		noPagination: 'false',
	});
	const { body } = await clientRequest.get<undefined, ProjectsApiResponse>(
		`/api/personal-dashboard/projects${query ? `?${query}` : ''}`,
		{ schema: undefined },
	);
	return body;
};

export const getProject = async (projectId: string): Promise<Project | undefined> => {
	try {
		const { body } = await clientRequest.get(`/api/personal-dashboard/projects/${projectId}`, {
			schema: projectSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get project:', error);
		return undefined;
	}
};

export const createProject = async (data: Record<string, unknown>): Promise<{ id: string }> => {
	const { body } = await clientRequest.post<undefined, { id: string }>('/api/personal-dashboard/projects', data, {
		schema: undefined,
	});
	return body;
};

export const updateProject = async (id: string, data: Record<string, unknown>): Promise<{ id: string }> => {
	const { body } = await clientRequest.put<undefined, { id: string }>(`/api/personal-dashboard/projects/${id}`, data, {
		schema: undefined,
	});
	return body;
};

export const archiveProject = async (projectId: string): Promise<void> => {
	await clientRequest.del(`/api/personal-dashboard/projects/${projectId}`, {});
};

export const restoreProject = async (projectId: string): Promise<void> => {
	await clientRequest.put(`/api/personal-dashboard/projects/${projectId}/restore`, {}, { schema: undefined });
};

export const getProjectLogs = async (
	projectId: string,
	params?: { from?: string; until?: string; page?: number; sort?: string },
): Promise<LogApiResponse> => {
	const query = constructQuery({
		from: params?.from,
		until: params?.until,
		page: params?.page,
		sort: params?.sort || 'timestamp:desc',
	});
	const { body } = await clientRequest.get(`/api/personal-dashboard/projects/${projectId}/logs?${query}`, {
		schema: logApiResponseSchema,
	});
	return body;
};
